module.exports = __webpack_public_path__ + "web/img/verify3.810c3695.png";